import { render, staticRenderFns } from "./course_progress.vue?vue&type=template&id=e887a248"
import script from "./course_progress.vue?vue&type=script&lang=js"
export * from "./course_progress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports